import '#styles/collection.css'
import '#components/editorial-card'
import '#components/complete-the-look'
import '#components/shop-the-look-drawer'

const hasFilterParam = () => {
  const params = new URLSearchParams(window.location.search)

  return [...params.keys()].some((key) => key.startsWith('filter'))
}

const toggleEditorialVisibility = () => {
  document.documentElement.classList.toggle('is-filtering', hasFilterParam())
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', toggleEditorialVisibility)
} else {
  toggleEditorialVisibility()
}

document.addEventListener('facet:update', () => {
  toggleEditorialVisibility()
})
